module.exports = __webpack_public_path__ + "static/media/Profile.00934c0c.svg";